import { render } from "./PoweredByCodeGears.vue?vue&type=template&id=18b51364&scoped=true"
const script = {}

import "./PoweredByCodeGears.vue?vue&type=style&index=0&id=18b51364&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18b51364"]])

export default __exports__